const goToCollectionRequirements = (
  idOfColl,
  collection,
  history,
  setComment,
  month,
  day,
  curYear
) => {
  const collAry = collection[idOfColl];
  const { type } = collAry.details;

  if (
    type === 'local'
    && collection[idOfColl].title.includes('Holiday')) {
    return setComment('holiday');
  }

  if (
    type === 'local'
    && collection[idOfColl].title.includes('Tree')) {
    return setComment('tree');
  }

  const collectionId = (
    collAry
    && collAry.details
    && collAry.details.path
  )
    ? collAry.details.path.substring(0, collAry.details.path.length - 5)
    : null;

  const eventId = (
    collAry
    && collAry.details
    && collAry.details.path
    && collAry.details.path.includes('event')
  )
    ? collAry.details.path.substring(0, collAry.details.path.length - 5)
    : null;

  if (
    type === 'remote'
    && eventId
  ) return history.push('/cal/event-list', { depoEventId: eventId, type: 'drop-event-list' });

  return history.push('/cal/collection-requirements', {
    id: collectionId, month, day, curYear
  });
};

export default goToCollectionRequirements;
